import { Component, OnInit, Inject          } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA      } from '@angular/material/dialog';
import { DeviceDetail } from 'src/app/beans/device/device.detail.bean';
import { DialogsReturnCode                  } from 'src/app/enums/dialogs/returnCode.enum';
import { HandlerManager                     } from 'src/app/managers/handler/handler.manager';
import { LoadingManager                     } from 'src/app/managers/loading/loading.manager';
import { SessionManager                     } from 'src/app/managers/session/session.manager';

@Component
({
  selector: 'device-clone-dialog',
  templateUrl: './device.clone.dialog.html',
  styleUrls: ['./device.clone.dialog.scss'],
})

export class DeviceCloneDialog implements OnInit 
{
  title       : string = "dialog.generic.title"
  body        : string = "dialog.generic.body"
  confirm_text: string = "dialog.generic.confirm"
  cancel_text : string = "dialog.generic.cancel"

  deviceName_text : string = ""
  counterName_text: string = ""

  deviceName: string
  counterName: string

  type: number

  constructor
  (
    private dialogRef : MatDialogRef<DeviceCloneDialog>,
    @Inject(MAT_DIALOG_DATA) public data: any          ,
  ) {}

  ngOnInit(): void
  {
    if(this.data)
    {
      if(this.data.title       ) this.title             = this.data.title 
      if(this.data.body        ) this.body              = this.data.body
      if(this.data.confirm_text) this.confirm_text      = this.data.confirm_text
      if(this.data.cancel_text ) this.cancel_text       = this.data.cancel_text
      if(this.data.deviceName  ) this.deviceName_text   = this.data.deviceName
      if(this.data.counterName ) this.counterName_text  = this.data.counterName
      if(this.data.type        ) this.type              = this.data.type
    }
  }

  //---------------------------------------------------------------------------------------------------
  
  cancel()
  {
    this.dialogRef.close
    ( 
      {
        code: DialogsReturnCode.OPERATION_DECLINED
      }
    )
  }

  continue()
  { 
      if(this.deviceName && ( this.type != 20  || this.counterName ))
      {
        this.dialogRef.close
        ( 
          {
            code       : DialogsReturnCode.OPERATION_ACCEPTED
          , deviceName : this.deviceName
          , counterName: this.counterName
          }
        )
      }
  }
}
